import { usersService } from "../../services/users";
import { useWSMutation } from "../helpers";
import { ReactQueryMutationsConfig } from "react-query";
import { AxiosError } from "axios";
import bookkeepingService from "../../services/bookkeeping";
import {
  IPendingWithholding,
  IPendingWithholdingCreate,
  IPendingWithholdingUpdate
} from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import {
  QUERY_TAXES_PENDING_WITHHOLDING,
  QUERY_TAXES_PENDING_WITHHOLDING_LIST
} from "./keys";

export const useWith = () =>
  useWSMutation(
    (userId: string) =>
      usersService.activity.update(userId, {
        flows: {
          settingsFoundingMemberInterest: {
            version: 1,
            currentStep: 1,
            totalSteps: 1,
            complete: true
          }
        }
      }),
    {
      // dependencies: [QUERY_USERS_ACTIVITIES]
    }
  );

export const useCreatePendingWithholding = (
  config?: ReactQueryMutationsConfig<
    IPendingWithholding,
    AxiosError,
    IPendingWithholdingCreate
  >
) =>
  useWSMutation(
    async (request: IPendingWithholdingCreate) =>
      await bookkeepingService.createPendingWithholding(request),
    {
      dependencies: [QUERY_TAXES_PENDING_WITHHOLDING_LIST],
      ...config
    }
  );

export const useUpdatePendingWithholding = (
  config?: ReactQueryMutationsConfig<
    IPendingWithholding,
    AxiosError,
    { id: string } & IPendingWithholdingUpdate
  >
) =>
  useWSMutation(
    async ({ id, ...params }) =>
      await bookkeepingService.updatePendingWithholding(id, params),
    {
      dependencies: [
        QUERY_TAXES_PENDING_WITHHOLDING_LIST,
        QUERY_TAXES_PENDING_WITHHOLDING
      ],
      ...config
    }
  );
